export class SensorSweepTrigger200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensorSweepTrigger200Response.attributeTypeMap;
    }
    constructor() {
    }
}
